module.exports = __webpack_public_path__ + "static/media/blockchain.b73e0cab.svg";